import { setCookie } from "tiny-cookie"

function initialState() {
  return {
    userMode: "MANAGE", // "MANAGE" or "MENTOR" or "MENTEE"
    menteeId: 0,
    menteeName: ""
  }
}

const state = initialState

const getters = {
  getMenteeId: state => state.menteeId,
  getUserMode: state => state.userMode,
  getMenteeName: state => state.menteeName,
  getAlerts: state => state.alerts
}

// mutations
const mutations = {
  setMenteeId(state, menteeId) {
    state.menteeId = menteeId
  },
  setUserMode(state, mode) {
    setCookie("userMode", mode)
    state.userMode = mode
  },
  setMenteeName(state, menteeName) {
    state.menteeName = menteeName
  },
  reset(state) {
    // acquire initial state
    const s = initialState()
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },
  addAlert(state, alert) {
    state.alerts.push(alert)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
